import React from "react"
import { Flex, Form, InputNumber, Radio as AntdRadio, Select, Space, Tooltip } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import { Card } from "ui/Card"
import { Text } from "ui/Typography"
import { Radio } from "ui/Radio"
import styles from "./DurationAndCutOff.module.css"
import { spacings } from "themes/variables"

const CUT_OFF_UNIT_OPTIONS = [
  { value: "minute", label: "minutes before start" },
  { value: "hour", label: "hours before start" },
  { value: "day", label: "days before start" },
]

export const DurationAndCutOff = () => (
  <Card title={"Duration & Cut Off"} className="mb-xl">
    <Flex gap={48} wrap="wrap">
      <Form.Item
        label={<Text className={styles.sectionLabel}>{"Experience Duration"}</Text>}
        required
        style={{ marginBottom: 0 }}
      >
        <Flex align="center" gap={spacings.XS}>
          <Form.Item name="duration_value" noStyle rules={[{ required: true, message: "Experience duration value is required" }]}>
            <InputNumber min={1} className={styles.numberInput} size="middle" />
          </Form.Item>
          <Form.Item name="duration_unit" noStyle rules={[{ required: true, message: "Experience duration unit is required" }]}>
            <AntdRadio.Group>
              <Radio value="minute">{"Minutes"}</Radio>
              <Radio value="hour">{"Hours"}</Radio>
            </AntdRadio.Group>
          </Form.Item>
        </Flex>
      </Form.Item>

      <Form.Item
        label={
          <Flex align="center" gap={spacings.XS}>
            <Text className={styles.sectionLabel}>{"How long before the start date must the activity be booked?"}</Text>
            <Tooltip placement="right" title={"Cutoff time before guests can no longer book"}>
              <InfoCircleOutlined className={styles.infoIcon} />
            </Tooltip>
          </Flex>
        }
        required
        className="mb-0"
      >
        <Space.Compact>
          <Form.Item name="cut_off_value" noStyle rules={[{ required: true, message: "Cut off value is required" }]}>
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item name="cut_off_unit" noStyle rules={[{ required: true, message: "Cut off unit is required" }]}>
            <Select options={CUT_OFF_UNIT_OPTIONS} />
          </Form.Item>
        </Space.Compact>
      </Form.Item>
    </Flex>
  </Card>
)
